<template>
    <v-container fill-height>
      <v-layout justify-center align-center column>
        <h1 class="title">{{ message }}</h1>
        <h1 v-if="error && error.statusCode === 404">Page not found</h1>
        <h1 v-else-if="error && error.statusCode === 401">Permission Denied</h1>
        <h1 v-else>An error occurred</h1>
  
        <!-- Optional manual refresh buttons if needed -->
        <v-btn
          v-if="error.to === 'lessons'"
          depressed
          color="primary"
          :to="localePath('/')"
        >
          Lesson Library
        </v-btn>
        <v-btn
          v-if="error.statusCode === 404 || error.statusCode === 401"
          depressed
          :to="localePath('/')"
        >
          Home
        </v-btn>
        <v-btn v-else depressed color="primary" @click="refreshPage">
          Refresh
        </v-btn>
      </v-layout>
    </v-container>
  </template>
  
  <script>
  export default {
    name: 'Error',
    props: {
      error: {
        type: Object,
        required: true,
        default() {
          return {};
        }
      }
    },
    head() {
      return {
        title: this.message,
        meta: []
      };
    },
    mounted() {
      console.log(this.error);  // Log the error object to check its content
      // Automatically refresh the page after 5 seconds
      // if the error is not a 404 (Not Found) or 401 (Permission Denied)
      if (!this.error.statusCode || (this.error.statusCode !== 404 && this.error.statusCode !== 401)) {
          // setTimeout(() => {
          //   this.refreshPage();  // Delay the refresh to see if other conditions are met first
          // }, 500); // 5 seconds delay
      }
    },
    methods: {
      refreshPage() {
        window.location.reload(true); // Force reload from the server
      }
    },
    computed: {
      message() {
        return this.error.message || `<%= messages.client_error %>`;
      }
    }
  };
  </script>
  